/* eslint-disable camelcase */
import axios from 'axios'
import { wmSign, wmAes, wm_aes_for_web } from '../../apiFunction/encrypt'
import { GetTimeStamp } from '../../apiFunction/getDate'

const appURL = `${process.env.REACT_APP_APP_URL}/api`
const header = {
  'Content-Type': 'application/json',
  'Accept-Language': 'en',
  'app-id': process.env.REACT_APP_ID,
  'device-uuid': process.env.REACT_APP_DEVICE_UUID
}
async function GetRegisterCheck (GetRegisterCheckData) {
  const body = {
    request_parameter: {
      register_check: {
        mobile: wmAes(GetRegisterCheckData.phone),
        password: wmAes(GetRegisterCheckData.password)
      }
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/register_check`, data, { headers: header })
  return response.data
}

async function GetCheck3rdCrmData (GetRegisterCheckData) {
  const body = {
    api_name: '/member/check_third_party_crm_data',
    request_parameter: {
      payload: wmAes('{"mobile":"' + `${GetRegisterCheckData.phone}` + '"}')
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/relay/send_payload`, data, { headers: header })
  return response.data
}

async function GetRegister (GetRegisterCheckData) {
  const body = {
    request_parameter: {
      register: baseRegisterParameter(GetRegisterCheckData)
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/register`, data, { headers: header })
  return response.data
}

async function GetRegisterWithThirdPartyCrm (GetRegisterCheckData, check3rdCrmData) {
  const body = {
    request_parameter: {
      register: baseRegisterParameter(GetRegisterCheckData),
      third_party_crm_data: wmAes(JSON.stringify(check3rdCrmData))
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/register_with_third_party_crm_data`, data, { headers: header })
  return response.data
}

function baseRegisterParameter (registerData) {
  return {
    mobile: wmAes(registerData.phone, process.env.REACT_APP_AES_KEY),
    password: wmAes(registerData.password, process.env.REACT_APP_AES_KEY),
    name: registerData.name,
    gender: registerData.gender,
    security_question: registerData.forgetSecurity,
    security_answer: registerData.security,
    birthday: registerData.birthday,
    email: registerData.email,
    city: registerData.city,
    district: registerData.district,
    address: registerData.address
  }
}

async function GetRegisterVerify (req) {
  const body = {
    temp_access_token: req.tempAccessToken,
    request_parameter: {
      verify_code: req.formValue
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/register_verify`, data, { headers: header })
  return response.data
}

async function GetResendRegisterVerify (req) {
  const body = {
    temp_access_token: req.tempAccessToken,
    request_parameter: {},
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body, process.env.REACT_APP_SIGN_KEY)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/resend_register_verify`, data, { headers: header })
  return response.data
}

async function GetRegisterAuthorize () {
  const memberAccessToken = sessionStorage.getItem('member_access_token')
  const rurl = sessionStorage.getItem('rurl')
  const xToken = encodeURIComponent(wm_aes_for_web(memberAccessToken))
  const finalUrl = rurl + `&x_token=${xToken}`
  const authorizeHeader = { ...header, accept: 'application/json', 'X-MMRM-TOKEN': wmAes(memberAccessToken) }
  const response = await axios.get(`${finalUrl}`, { headers: authorizeHeader })
  return response.data
}

export { GetRegisterCheck, GetCheck3rdCrmData, GetRegister, GetRegisterVerify, GetResendRegisterVerify, GetRegisterAuthorize, GetRegisterWithThirdPartyCrm }
